import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { NAV_LINKS, whatsappUrl } from "./constants";

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[#E1E7E3] shadow-[0_1px_0_rgba(14,26,20,0.04)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 grid place-items-center rounded-full bg-[#1F6E45] text-white font-display text-sm">
            S
          </span>
          <span className="font-heading text-[#0E1A14] text-[17px] tracking-tight font-bold">
            Sacco<span className="text-[#1F6E45]">.</span>Nutrizione
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-[#4A5A52] hover:text-[#1F6E45] transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-cta"
            className="hidden md:inline-flex items-center gap-2 bg-[#1F6E45] text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#144A2E] transition-colors active:scale-95"
          >
            <MessageCircle size={16} strokeWidth={2.2} />
            Prenota ora
          </a>
          <button
            aria-label="Menu"
            onClick={() => setOpen((o) => !o)}
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-[#0E1A14] p-2"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-[#E1E7E3]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#0E1A14] hover:text-[#1F6E45] text-base font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#1F6E45] text-white px-5 py-3 rounded-full text-sm font-semibold"
            >
              <MessageCircle size={16} /> Prenota su WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
